import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PartyRoleAssignment } from '../models/party-role-assignment.model';

@Injectable({
  providedIn: 'root'
})
export class PartyRoleAssignmentService {

  constructor(private http: HttpClient) {}

  /**
   * Obtiene todas las asignaciones activas de un usuario específico.
   * @param userId El ID del usuario
   */
  getUserAssignments(userId: string): Observable<PartyRoleAssignment[]> {
    return this.http.get<PartyRoleAssignment[]>(`${environment.api_service_party_role}/user/${userId}`);
  }

  /**
   * Asigna un nuevo rol a un usuario en un contexto específico (o global si todo es null).
   * @param assignment Objeto con la asignación
   */
  assignRole(assignment: PartyRoleAssignment): Observable<any> {
    return this.http.post<any>(environment.api_service_party_role, assignment);
  }

  /**
   * Revoca (borrado lógico) una asignación de rol.
   * @param assignmentId El ID de la tabla party_role_assignment
   */
  revokeRole(assignmentId: string): Observable<any> {
    return this.http.delete<any>(`${environment.api_service_party_role}/${assignmentId}`);
  }
}